var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((30),function(item,idx){return _c('div',{key:idx},[(_vm.data===idx)?_c('span',[_vm._v(" — "+_vm._s(_vm.$t('common.item'+(idx+1)))+" — ")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }